import { Injectable } from '@angular/core';
import { ScriptPlacement } from '@spartacus/core';
import { Observable } from 'rxjs';
import { filter, map, withLatestFrom } from 'rxjs/operators';
import { TranslationService } from '../../../core/i18n';
import { SiteFamilyConfigFacade } from '../../../core/user';
import { ScriptLoader } from '../../../core/util';
import { WindowRef } from '../../../core/window';

@Injectable({ providedIn: 'root' })
export class OnlineChatService {
  constructor(
    private siteFamilyConfigService: SiteFamilyConfigFacade,
    private scriptLoader: ScriptLoader,
    private translationService: TranslationService,
    private winRef: WindowRef
  ) {}

  initOnlineChat(): Observable<boolean> {
    return this.siteFamilyConfigService.getSiteFamilyConfig().pipe(
      filter((config) => Boolean(config?.onlineChatConfig)),
      map((config) => config.onlineChatConfig),
      withLatestFrom(this.translationService.translate('common.chat_heading')),
      map(([onlineChatConfig, chatHeading]) => {
        const url = `${onlineChatConfig.baseUrl}/CS/javascript/chat.js`;
        if (this.scriptLoader.hasScript(url)) {
          return;
        }
        this.scriptLoader.embedScript({
          src: url,
          params: undefined,
          attributes: {
            id: 'superoffice',
            type: 'text/javascript',
            'data-topicid': onlineChatConfig.topicId,
            'data-title': onlineChatConfig.title,
            'data-theme': onlineChatConfig.theme,
            'data-color': onlineChatConfig.color,
            'data-font': onlineChatConfig.font,
            'data-delay': onlineChatConfig.delay,
          },
          callback: () => {
            this.initOnlineChatSession(chatHeading);
          },
          errorCallback: undefined,
          placement: ScriptPlacement.BODY,
        });
      }),
      map(() => true)
    );
  }

  private initOnlineChatSession(frameTitle: string) {
    const { SuperOffice_setupChat } = this.winRef.nativeWindow as any;
    SuperOffice_setupChat();
    const wrapper = this.winRef.document?.getElementById('SuperOffice_chatdiv');

    if (wrapper) {
      wrapper.role = 'region';
      wrapper.ariaLabel = frameTitle;
    }

    const frame = this.winRef.document?.getElementById('SuperOffice_chatframe');
    if (frame) {
      frame.title = frameTitle;
    }

    return SuperOffice_setupChat;
  }
}
